import { createSlice } from '@reduxjs/toolkit';

import { loadSolutions } from '../thunks/solutions.thunk';
import { ISolutionsState } from './types';

export const SEARCH_LIMIT = 6;

const initialState: ISolutionsState = {
  query: '',
  solutions: null,
  error: null,
  isLoading: false,
  // Search can be also triggered by back button or history restoration
  isUserTypedSearch: false,
};

export const solutionsSlice = createSlice({
  name: 'solutions',
  initialState,
  reducers: {
    setIsUserTypedSearch: (state, action) => {
      state.isUserTypedSearch = action.payload;
    },
    resetSolutions: (state) => ({
      ...initialState,
      isUserTypedSearch: state.isUserTypedSearch,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadSolutions.pending, (state, action) => {
      return {
        ...state,
        query: action.meta.arg.query,
        error: null,
        isLoading: true,
      };
    });

    builder.addCase(loadSolutions.fulfilled, (state, action) => {
      return {
        ...state,
        solutions: action.payload,
        error: null,
        isLoading: false,
        isUserTypedSearch: false,
      };
    });

    builder.addCase(loadSolutions.rejected, (state, action) => {
      return {
        ...state,
        error: action.error as string,
        isLoading: false,
        isUserTypedSearch: false,
      };
    });
  },
});
